import { Modal } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { Button } from "@nextui-org/react";
import React, { useState } from "react";

import { Row } from "@/components/customComponents";
import Trans from "@/components/Trans/Trans";

import StickyCard from "../../../components/Checkout/StickyCard";
import { ModalChangeCardProps } from "../types";

const ModalChangeCard = ({ isOpen, onOpenChange, onChangeCard, isActioning, error }: ModalChangeCardProps) => {
  const { t } = useTranslation();
  const [isCardValid, setIsCardValid] = useState(false);
  const [creditCardToken, setCreditCardToken] = useState<string | null>(null);
  return (
    <Modal
      title={t("subscription:portal.modalChangeCard.title")}
      classNames={{ title: "text-center pl-[28px]" }}
      description={t("subscription:portal.modalChangeCard.description")}
      open={isOpen}
      onOpenChange={onOpenChange}
      backdrop="blur"
    >
      <StickyCard setIsCardValid={setIsCardValid} setCreditCardToken={setCreditCardToken} />
      {!!error && <p className="flex text-danger justify-center">{error}</p>}
      <Row justify="end">
        <Button
          isDisabled={isActioning || !isCardValid}
          isLoading={isActioning}
          color="primary"
          onPress={() => onChangeCard(creditCardToken!)}
          aria-label="update"
        >
          {isActioning ? (
            <Trans i18nKey="subscription:portal.modalChangeCard.updating" />
          ) : (
            <Trans i18nKey="subscription:portal.modalChangeCard.updateCard" />
          )}
        </Button>
      </Row>
    </Modal>
  );
};

export default ModalChangeCard;
